export default class BillingProductCreateRequest {
  public name: string;
  public description: string;

  constructor(options) {
    this.name = options.name;
    this.description = options.description;
  }
}
